import { useCallback, useEffect } from 'react';
import { setIsColumnLayoutMode } from '../redux/actions/commonActions';
import { thunkSetStageDimensions } from '../redux/actions/gameDimensionsActions';
import { selectPanelPositionSetting } from '../redux/reducers/selfDataReducer';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { getIsColumnLayoutMode } from '../utils/layoutModeUtils';
import { useDebouncedResizeHandler } from './useDebouncedResizeHandler';
/**
 * Handles resizing behavior for the poker table stage.
 */
export function usePokerSceneResize(containerRef) {
    const dispatch = useAppDispatch();
    const isPanelOpen = useAppSelector((state) => !!state.panels.activePanelType);
    const hasFooterAlert = useAppSelector((state) => !!state.footerAlert.alert);
    const isColumnLayoutMode = useAppSelector((state) => state.common.isColumnLayoutMode);
    const panelPositionSetting = useAppSelector(selectPanelPositionSetting);
    const updateIsColumnLayoutMode = useCallback(() => {
        const newIsColumnLayoutMode = getIsColumnLayoutMode(panelPositionSetting);
        if (newIsColumnLayoutMode !== isColumnLayoutMode) {
            dispatch(setIsColumnLayoutMode(newIsColumnLayoutMode));
        }
    }, [dispatch, isColumnLayoutMode, panelPositionSetting]);
    const updateStageDimensions = useCallback(() => {
        const container = containerRef.current;
        if (!container) {
            return;
        }
        const { width, height } = container.getBoundingClientRect();
        dispatch(thunkSetStageDimensions({ w: width, h: height }));
    }, [containerRef, dispatch]);
    const handleResize = useCallback(() => {
        updateStageDimensions();
        updateIsColumnLayoutMode();
    }, [updateIsColumnLayoutMode, updateStageDimensions]);
    // handle stage resize when stage container ref changes or panel open/closed state changes:
    useEffect(() => {
        // don't debounce in this case, only in response to window resize event:
        handleResize();
    }, [containerRef, handleResize, isPanelOpen, hasFooterAlert]);
    useDebouncedResizeHandler(handleResize);
}
